export interface cv_RoleInPool {
    C_RoleInPool_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    ModifiedBy: string;
    RoleInPool: string;
    SortOrder: number | null;
    Version: number;
}
